var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-popover",on:{"!mousemove":function($event){return _vm.handleMouseMove.apply(null, arguments)}}},[_c('div',{on:{"mouseenter":_vm.fixPosition}},[_vm._t("wrapper")],2),_c('div',{ref:"content",staticClass:"c-popover__content",style:(_vm.contentStyles)},[_vm._t("content",null,{"position":{ left: _vm.left, top: _vm.top }})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }